import React from "react";

function DownloadIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="26"
      viewBox="0 0 19 26"
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g fill="currentColor" fillRule="nonzero">
          <path d="M18.302 4.848l-4.15-4.15A2.375 2.375 0 0012.475 0h-10.1A2.383 2.383 0 000 2.38v20.579a2.375 2.375 0 002.375 2.374h14.25A2.375 2.375 0 0019 22.96V6.529c0-.627-.252-1.236-.698-1.681zm-5.634-3.235a.778.778 0 01.366.207l4.15 4.15a.778.778 0 01.208.367h-4.724V1.613zm4.75 21.346a.794.794 0 01-.793.791H2.375a.794.794 0 01-.792-.791V2.379c0-.435.356-.796.792-.796h8.71v5.15c0 .658.53 1.184 1.187 1.184h5.145v15.042zm-7.126-12.271a.396.396 0 00-.396-.396h-.792a.396.396 0 00-.396.396v4.355H6.103c-.545 0-1.019.317-1.237.827-.223.52-.118 1.12.269 1.524l3.37 3.552a1.365 1.365 0 001.989 0l3.37-3.55a1.407 1.407 0 00.27-1.526 1.333 1.333 0 00-1.238-.827h-2.604v-4.355zm2.12 5.938L9.5 19.694l-2.911-3.068h5.822z"></path>
        </g>
      </g>
    </svg>
  );
}

export default DownloadIcon;
